export const ClickEvent = 'click';
export interface ClickPayload {
  event: string;
}
